import { useMemo } from 'react'
import { codiceQr } from '../vendor/codice-qr.ts'

/**
 * Il codice QR come un solo percorso SVG, con il margine chiaro di quattro moduli che i lettori
 * chiedono. Moduli scuri su fondo chiaro anche nel tema scuro: molte app non leggono i codici invertiti.
 * Lo usano il secondo fattore (pagine/SecondoFattore.tsx) e l'invito all'app (AvvisoAppTelefono.tsx);
 * la misura la decide chi lo contiene, le classi sono in stile-secondo-fattore.css.
 */
export function DisegnoQr({ testo, etichetta }: { testo: string; etichetta: string }) {
  const { lato, percorso } = useMemo(() => {
    const moduli = codiceQr(testo)
    const margine = 4
    let d = ''
    moduli.forEach((riga, y) => riga.forEach((scuro, x) => {
      if (scuro) d += `M${x + margine} ${y + margine}h1v1h-1z`
    }))
    return { lato: moduli.length + 2 * margine, percorso: d }
  }, [testo])
  return (
    <svg className="fattore-qr" viewBox={`0 0 ${lato} ${lato}`} shapeRendering="crispEdges"
         role="img" aria-label={etichetta}>
      <rect className="fattore-qr-fondo" width={lato} height={lato} />
      <path className="fattore-qr-moduli" d={percorso} />
    </svg>
  )
}
